// onboardingConfig.js
const HOME_ROUTES = {
  Newuser: '/validationpage',
  Existing: '/profile',
};




export const resolveHomeRoute = (userType) => {
  return HOME_ROUTES[userType] || HOME_ROUTES.Existing;
};

